import QuizSearchContainer from "./QuizSearchContainer";


export default QuizSearchContainer;